import React, { Component } from 'react'

export class Deductionholdamount extends Component {
    render() {
        return (
                <div className="box">
                <div className="box-body">
                    <div className="box-header">
                        <h3 className="box-title">Deduction/Hold Amount</h3>
                    </div>
                    <div className="col-md-12">
                        <div id="error_msg_display_board"></div>
                        <form action="partworksdetails/deducationentry">
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Date of Bill / Order</label> 
                                <input type="text" placeholder="DD-MM-YYYY" name="billdate" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Deduction Type</label> 
                                <select className="form-control" name="bill_type">
                                    <option value="">Select Deduction Type</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Remarks</label> 
                                <input type="text" name="billdescription" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Amount</label> 
                                <input type="text" name="billamount" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4" style={{padding: '2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </form>	
                </div>
                <div className="col-md-4">
                    <h3 className="text-center">Deduction Type List</h3>
                    <table className="table table-bordered">
                        <thead>
                            <tr className="bg-gray">
                            <th className="text-center">Deduction Type</th>
                            <th className="text-center">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td></td>
                            <td className="text-right"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-md-8">
                    <h3 className="text-center">Date of Bill / Order List</h3>
                    <table className="table table-bordered" id="progressextraitems">
                        <thead>
                            <tr className="bg-gray">
                            <th className="text-center">Date of Bill / Order</th>
                            <th className="text-center">Deduction Type</th>
                            <th className="text-center">Remarks</th>
                            <th className="text-center">Amount</th>
                            <th className="text-center">Edit</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                </div>
                </div>
        )
    }
}

export default Deductionholdamount
